import {
  Backdrop,
  CircularProgress,
  Dialog,
  Menu,
  MenuItem,
  Skeleton,
  Tooltip
} from "@mui/material";
import {
  ArrowLeft,
  Check,
  ChevronDown,
  Clock,
  Edit,
  X,
} from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { CalendarFill, QuestionCircleFill } from "react-bootstrap-icons";
import { useQueryClient } from "@tanstack/react-query";
import DatePicker from "react-datepicker";
import { Link, useParams, useLocation } from "react-router-dom";
import API from "../../API/newIndex";
import { getParticularBlog, updateBlog } from "../../services/blogService";
import { ChangePathContext } from "../../App";
import { BardSvg } from "../../Assets/StaticData/BardSvg";
import Breadcrumbs from "../../controllers/breadCrumbs";
import { GenerateSlugName } from "../../controllers/GenerateSlugName";
import { clientData } from "../../controllers/GetClient";
import ImageConfirmation from "../../controllers/ImageConfirmation";
import ImageGeneratePrompt from "../../controllers/ImageGeneratePrompt";
import ImageUploader from "../../controllers/ImageUploader";
import { useLastRoute } from "../../controllers/LastRouteContext";
import { parentNavigate } from "../../controllers/ParentNavigate";
import SourceCode from "../../controllers/SourceCode";
import { Transition } from "../../controllers/Transition";
import UpdateCustomMetaField from "../../controllers/UpdateCustomMetaField";
import { useUser } from "../../controllers/UserContext";
import { useAuthor } from "../../controllers/AuthorContext";
import { useRoutingByType } from "../../controllers/useRouting";
import { uploadTextEditorImage, scrollToFirstError } from "../../utilities/staticFunction";
import AiTextGenerate from "../AiTextGenerate";
import {
  ButtonComponent,
  DetailsComponent,
  InputComponent,
  SelectComponent,
  RichTextEditor
} from "@shopeasy-dashboard-ui/ui-library";
import TextareaComponent from "../FormInput/TextareaComponent";
import Notification from "../Notification";
const UpdateBlog = () => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const prevPage = location.state?.prevPage || 1;
  const prevUrl = location.state?.prevUrl;
  const lastRoute = useLastRoute();
  const defaultBackUrl = useMemo(
    () => prevUrl || lastRoute || (prevPage > 1 ? `/blog/post?page=${prevPage}` : `/blog/post`),
    [prevUrl, lastRoute, prevPage]
  );
  const { userInfo, fetchUserInfo } = useUser();

  useEffect(() => {
    if (!userInfo && typeof fetchUserInfo === "function") {
      fetchUserInfo();
    }
  }, [userInfo, fetchUserInfo]);

  const isCanSelectAuthor = useMemo(() => {
    if (!userInfo) return false;

    if (
      userInfo?.permissions === "all" ||
      userInfo?.data?.permissions === "all" ||
      userInfo?.is_admin === true ||
      userInfo?.is_owner === true
    ) {
      return true;
    }

    const getAllRoleStrings = (obj) => {
      if (!obj) return [];
      let results = [];
      if (typeof obj === "string") {
        results.push(obj);
      } else if (Array.isArray(obj)) {
        obj.forEach((item) => results.push(...getAllRoleStrings(item)));
      } else if (typeof obj === "object") {
        for (const key of Object.keys(obj)) {
          if (["role", "roles", "staff_role", "role_name", "type", "user_role"].includes(key)) {
            results.push(...getAllRoleStrings(obj[key]));
          }
        }
      }
      return results;
    };

    const allStrings = [
      ...getAllRoleStrings(userInfo),
      ...getAllRoleStrings(userInfo?.data),
      ...getAllRoleStrings(userInfo?.user),
    ].map((s) => String(s).toLowerCase().trim());

    return allStrings.some((str) => str.includes("admin") || str.includes("manager"));
  }, [userInfo]);

  const authorLabel = useMemo(() => {
    const translated = t("lang_Author");
    return translated && !translated.startsWith("lang_") ? translated : "Author";
  }, []);

  const authorPlaceholder = useMemo(() => {
    const translatedSelect = t("lang_select");
    const selectStr = translatedSelect && !translatedSelect.startsWith("lang_") ? translatedSelect : "Select";
    return `${selectStr} ${authorLabel}`;
  }, [authorLabel]);
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const params = useParams();
  const [warn, setwarn] = useState(false);
  const [elem, setElem] = useState();
  // image upload logic
  const [image, setimage] = useState();
  const [scheduleTimeDate, setScheduleTimeDate] = useState();
  const [isSchedule, setIsSchedule] = useState(false);
  const [meta, setMeta] = useState({ meta_description: "", meta_title: "", meta_image: "" });
  const { meta_description, meta_title, meta_image } = meta;
  const [isMetaTitleCustom, setIsMetaTitleCustom] = useState(false);
  const [SelectCategory, setSelectCategory] = useState([]);
  const [description, setDescription] = useState();
  const [secondDescription, setSecondDescription] = useState();
  const [title, setTitle] = useState();
  const [err, setErr] = useState(false);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [enableSlug, setEnableSlug] = useState(false);
  const slugInputRef = useRef(null);
  const [slugEdited, setSlugEdited] = useState(false);
  const [slugName, setSlugName] = useState("");
  const handleSlug = async (slug) => {
    if (slug?.length) {
      setSlugName(await GenerateSlugName(slug));
    } else {
      setSlugName("");
    }
  };
  const [isChange, setIsChange] = useState(false);
  const [meta_fields, setmeta_fields] = useState({});
  const [isCustomField, setIsCustomField] = useState(false);
  const [customFieldList, setCustomFieldList] = useState([]);
  const [customFieldErrors, setCustomFieldErrors] = useState({});
  const { authorsList, fetchAuthors } = useAuthor();
  const [blogTemplate, setBlogTemplate] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("default");
  const [selectedAuthor, setSelectedAuthor] = useState("");

  const clientInfo = clientData;
  const protocol = process.env.REACT_APP_ENVIRONMENT === 'DEV' ? 'http://' : 'https://';
  const getMetaField = async () => {

    try {
      const ApiCall = await API({
        url: `/admin/metafieldgroup/getMetaFieldGroup/blog`,
        method: "get",
      });
      const result = ApiCall?.data;
      if (result?.data?.custom_fields?.length > 0) {
        setIsCustomField(true);
        setCustomFieldList(result?.data?.custom_fields || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // image upload logic
  const handleSetImage = (value) => {
    setIsChange(true);
    setimage(value);
  };
  const [formSpinner, setFormSpinner] = useState(true);
  const [isChangeDate, setIsChangeDate] = useState(false);
  const getPerticularBlog = async () => {
    setFormSpinner(true);
    try {
      const result = await getParticularBlog(params.blog_slug);
      setElem(result?.data);

      setimage(result?.data?.image);
      setSelectCategory(result?.data.blogcategory ? result?.data.blogcategory : "");
      setSelectedAuthor(result?.data?.user?._id || result?.data?.user || "");
      setMeta({
        meta_title: result?.data?.meta_title || "",
        meta_description: result?.data?.meta_description || "",
        meta_image: result?.data?.meta_image || "",
      });
      setIsMetaTitleCustom(Boolean(result?.data?.meta_title));
      setSecondDescription(result?.data?.description ? `${result?.data?.description}` : "");
      setTitle(result?.data?.title ? `${result?.data.title}` : "");
      setSlugName(result?.data?.blog_slug_name ? `${result?.data.blog_slug_name}` : "");
      setSlugEdited(Boolean(result?.data?.blog_slug_name));
      setBlogTagsArray(result?.data?.blog_tags);
      setScheduleTimeDate(
        result?.data?.blog_publish_date
          ? new Date(result?.data?.blog_publish_date)
          : null
      );
      setmeta_fields(result?.data?.custom_fields);
      setSelectedTemplate(result?.data?.theme_template);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setFormSpinner(false);
  };
  useEffect(() => {
    getPerticularBlog();
  }, [params?.blog_slug]);

  // get Parents Category
  const [Category, setCategory] = useState([]);
  const [isCategoryLoading, setIsCategoryLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const GetCategory = async (searchKey = "") => {
    setIsCategoryLoading(true);
    try {
      const data = await API({
        url: `/admin/blogcategory/GetBlogCategoriesWithParent`,
        method: "get",
        params: searchKey ? { searchkey: searchKey } : {},
      });
      if (data.status === 200 || data.status === 304) {
        const result = data?.data;
        setCategory(result?.data?.records || []);
      } else {
        setCategory([]);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
      setCategory([]);
    } finally {
      setIsCategoryLoading(false);
      setHasSearched(true);
    }
  };

  const categoryOptions = useMemo(() => {
    const records = Array.isArray(Category) ? Category : (Category?.data?.records || []);
    return records;
  }, [Category]);

  const GetBlogTemplate = async () => {
    try {
      const data = await API({
        url: `/admin/themestore/getthemetemplates?type=blogs`,
        method: "get",
      });
      if (data.status === 200 || data.status === 304) {
        const result = data?.data;
        setBlogTemplate(result?.templates);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  useEffect(() => {
    getMetaField();
    GetBlogTemplate();
    fetchAuthors();
  }, [fetchAuthors]);

  const [AiLoader, setAiloader] = useState(false);
  const [generateAiPopup, setGenareteAiPopup] = useState(false);
  const [generateDescriptionAiPopup, setGenareteDescriptionAiPopup] = useState(false);
  const [gerenateAiData, setGenerateDataAi] = useState({
    features: "",
  });
  const [imageGenerateAiPopup, setImageGenareteAiPopup] = useState(false);
  const [imageGenerateAiData, setImageGenerateDataAi] = useState({
    prompt: "",
    size: "1024x1024",
  });
  const [isConfirmationImageOpen, setIsConfirmationImageOpen] = useState(false);
  const [imageWarn, setImageWarn] = useState(true);
  const handleChangeAiData = (e) => {
    setIsChange(true);
    setGenerateDataAi({ ...gerenateAiData, [e.target.name]: e.target.value });
  };
  const handleSubmitAiData = (e) => {
    e.preventDefault();
    generateDesc(gerenateAiData);
    setGenareteAiPopup(false);
    setGenerateDataAi({
      features: "",
    });
  };
  const generateDesc = async () => {
    setAiloader(true);
    try {
      const payload = {
        name: gerenateAiData?.features,
      };
      let ApiCall = await API({
        url: "/admin/ai/keypoint_generate",
        method: "post",
        data: payload,
      });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        setAiloader(false);
        setDescription(result?.data);
        setGenareteDescriptionAiPopup(true);
      }
    } catch (error) {
      if (error?.response?.status === 429) {
        setIsNotification(true);
        setNotificationMsg(t("lang_Hit_chatgpt_limit"));
        setSeverity("warning");
      } else {
        setIsNotification(true);
        setNotificationMsg(error?.response?.data?.message);
        setSeverity("error");
      }
      setAiloader(false);
    }
  };

  const handleChangeImageAiData = (e) => {
    setImageGenerateDataAi({
      ...imageGenerateAiData,
      [e.target.name]: e.target.value,
    });
  };

  const generateImg = async () => {
    setAiloader(true);
    try {
      const payload = imageGenerateAiData;
      let ApiCall = await API({
        url: "/admin/ai/image_generator",
        method: "post",
        data: payload,
      });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        setimage(result?.data);
        setIsConfirmationImageOpen(true);
      }
    } catch (error) {
      if (error?.response?.status === 429) {
        setIsNotification(true);
        setNotificationMsg(t("lang_Hit_chatgpt_limit"));
        setSeverity("warning");
      } else {
        setIsNotification(true);
        setNotificationMsg(error?.response?.data?.message);
        setSeverity("error");
      }
    } finally {
      setImageGenareteAiPopup(false);
      setAiloader(false);
    }
  };

  const handleSubmitAiImage = (e) => {
    e.preventDefault();
    generateImg(gerenateAiData);
    setImageGenareteAiPopup(false);
    setImageGenerateDataAi({
      prompt: "",
      size: "1024x1024",
    });
  };
  const closeImageConfirmation = () => {
    setIsConfirmationImageOpen(false);
    setimage("");
  };
  const handleImageUpload = async () => {
    setIsConfirmationImageOpen(false);
    try {
      const res = await API({
        url: "/admin/ai/uploadGeneratedImage",
        method: "post",
        data: { imageUrl: image, folder: "blog" },
      });
      const result = res?.data;
      setimage(result?.data);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const handleBlogCategory = (id, name) => {
    if (id) {
      setIsChange(true);
      const cat = SelectCategory.find((x) => x._id === id);
      if (!cat) {
        setSelectCategory([...SelectCategory, { _id: id, blogcategory_name: name }]);
      }
    }
  };
  const [btnLoading, setBtnLoading] = useState(false);
  const HandleUpdate = async (e, key) => {
    e.preventDefault();

    // Validate custom fields
    if (isCustomField && customFieldList?.length > 0) {
      const cfErrors = {};
      for (const field of customFieldList) {
        const isRequired = Boolean(
          field?.is_required === true || field?.is_required === 1 || field?.required === true
        );
        if (isRequired) {
          const val = meta_fields?.[field.custom_field_name];
          if (val === undefined || val === null || (typeof val === "string" && val.trim() === "")) {
            cfErrors[field.custom_field_name] = `${field.custom_field_name} is required!`;
          }
        }
      }
      if (Object.keys(cfErrors).length > 0) {
        setCustomFieldErrors(cfErrors);
        setIsNotification(true);
        setSeverity("warning");
        const firstErrorField = Object.keys(cfErrors)[0];
        setNotificationMsg(`${firstErrorField} is required!`);
        scrollToFirstError(firstErrorField);
        return;
      }
    }

    setBtnLoading(true);
    if (slugName === "") {
      setErr(true);
    } else {
      try {
        let updatebody = {
          blogcategory: SelectCategory?.map((x) => x._id),
          title: title,
          image: image,
          description: secondDescription,
          blog_tags: blogTagsArray,
          user: selectedAuthor,
          ...meta,
          custom_fields: meta_fields,
          theme_template: selectedTemplate,
        };
        if (slugEdited && slugName) {
          updatebody = {
            ...updatebody,
            blog_slug_name: slugName,
          };
        }
        if (key === "publish") {
          updatebody = {
            ...updatebody,
            is_draft: false,
          };
        }
        updatebody = {
          ...updatebody,
          blog_publish_date: scheduleTimeDate,
        };
        const payload = updatebody;
        const data = await updateBlog(elem._id, payload);
        if (data.status === 200 || data.status === 304) {
          queryClient.invalidateQueries({ queryKey: ["blogs"] });
          setSaveChanges({
            isUnsaveChanges: false,
            showChangesPopup: false,
            backLink: defaultBackUrl,
            title: "edit blog",
          });
          parentNavigate(defaultBackUrl, { prevPage });
        }
      } catch (error) {
        setIsNotification(true);
        setNotificationMsg(error);
        setSeverity("error");
      }
    }
    setBtnLoading(false);
  };
  const generateMetaData = async (data, key) => {
    if (secondDescription?.length === 0) {
      setIsNotification(true);
      setNotificationMsg("Please enter description!");
      setSeverity("error");
    } else {
      setAiloader(true);
      try {
        const payload = {
          name: data,
        };
        if (key === "description") {
          let ApiCall = await API({
            url: "/admin/ai/meta_description",
            method: "post",
            data: payload,
          });
          const result = ApiCall?.data;
          setMeta({ ...meta, meta_description: result?.data });
        } else {
          let ApiCall = await API({
            url: "/admin/ai/meta_title",
            method: "post",
            data: payload,
          });
          const result = ApiCall?.data;
          setIsMetaTitleCustom(true);
          setMeta((prev) => ({ ...prev, meta_title: result?.data }));
        }
        setAiloader(false);
      } catch (error) {
        if (error?.response?.status === 429) {
          setIsNotification(true);
          setNotificationMsg(t("lang_Hit_chatgpt_limit"));
          setSeverity("warning");
        } else {
          setIsNotification(true);
          setNotificationMsg(error?.response?.data?.message);
          setSeverity("error");
        }
      } finally {
        setAiloader(false);
      }
    }
  };
  const [blogTagsValue, setBlogTagsValue] = useState([]);
  const [blogTagsArray, setBlogTagsArray] = useState([]);

  // save Group Values In Array
  const SaveblogTagsValue = () => {
    if (blogTagsValue.length > 0) {
      if (blogTagsValue.includes(",")) {
        let TagSeperator = blogTagsValue.split(",");

        let finalArray = [];
        let productTags = [...blogTagsArray, ...TagSeperator];
        productTags.filter((tag) => {
          const searchRegex = new RegExp(`^${tag.trim()}$`, "i");
          let exists = finalArray.some((finalTag) => searchRegex.test(finalTag));
          if (!exists) {
            finalArray.push(tag.trim());
          }
        });
        setBlogTagsArray(finalArray);
      } else {
        const searchRegex = new RegExp(`^${blogTagsValue}$`, "i");

        const exists = blogTagsArray.some((tag) => searchRegex.test(tag));

        if (!exists) {
          setBlogTagsArray((prev) => [...prev, blogTagsValue]);
        }
      }
      setBlogTagsValue("");
    }
  };

  // remove Tag
  const RemoveTag = (index) => {
    if (index > -1) {
      // only splice array when item is found
      blogTagsArray.splice(index, 1); // 2nd parameter means remove one item only
    }
    setBlogTagsArray([...blogTagsArray]);
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };
  const removeCategory = (id) => {
    const removeRelated = SelectCategory?.filter((x) => x._id !== id);
    setSelectCategory(removeRelated);
  };

  //Quil To HTML code and Functions
  const [html, setHtml] = useState({ htmlPP: false, code: "" });

  const saveHTML = (value) => {
    setHtml({ ...html, htmlPP: false });
    setSecondDescription(value);
  };
  const closeCode = () => {
    setHtml({ ...html, htmlPP: false });
  };
  useEffect(() => {
    if (isChange) {
      setSaveChanges({
        backLink: defaultBackUrl,
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "edit blog",
      });
    }
  }, [isChange, defaultBackUrl]);
  const checkChanges = () => {
    if (isChange) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: defaultBackUrl,
        title: "edit blog",
      });
    } else {
      parentNavigate(defaultBackUrl, { prevPage });
    }
  };

  const filterOptionsForCategory = (options, state) => {
    const normalizedInputValue = state.inputValue?.toLowerCase();
    if (!normalizedInputValue || normalizedInputValue.length < 3) {
      return [];
    }
    return options.filter((option) => {
      const combinedFields = `${option?.parent_category?.toLowerCase() || ''} ${option?.blogcategory_name?.toLowerCase() || ''}`;
      return combinedFields.includes(normalizedInputValue);
    });
  };
  const [autocompleteSearch, setAutocompleteSearch] = useState("");
  useEffect(() => {
    if (autocompleteSearch && autocompleteSearch.length >= 3) {
      const handler = setTimeout(() => {
        GetCategory(autocompleteSearch);
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    } else {
      setIsCategoryLoading(false);
      setHasSearched(false);
      setCategory([]);
    }
  }, [autocompleteSearch]);

  const blogRoute = useRoutingByType(`blog`);

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      {AiLoader && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={AiLoader}
          className="flex flex-col"
        >
          <CircularProgress color="inherit" />
          <p>{t("lang_ai_generate_content_loader")}</p>
        </Backdrop>
      )}
      <div className="h-auto overflow-y-auto pb-[130px] pt-5">
        <div className="px-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
            <div className="flex items-center space-x-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  checkChanges();
                }}
                className="back-arrow -ml-3.5"
              >
                <ArrowLeft />
              </button>
              <div className="flex-1 min-w-0">
                <Breadcrumbs
                  crumbs={[
                    { name: t("lang_Blog_Post"), path: defaultBackUrl },
                    {
                      name: t("lang_Update_Blog_Post"),
                      path: "/blog/post/edit-blog/post",
                    },
                  ]}
                />

                <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1">
                  <h4 className="text-xl md:text-2xl font-semibold text-primary">
                    {t("lang_Update_Blog")} - {elem?.title}
                  </h4>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://help.shopeasy.ai/articles/adding-a-new-blog/post"
                    className="how-it-works !m-0"
                  >
                    <QuestionCircleFill className="me-1.5" />
                    {t("lang_how_to_use")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-[20px]">

          {formSpinner ? (
            <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto space-y-4">
              <div className="secondary-bg-color shadow space-y-4 rounded-[6px] p-5 sm:p-[25px]">
                <div className="flex items-center space-x-4 w-full">
                  <div className="w-full">
                    <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                    <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                  </div>
                  <div className="w-full">
                    <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                    <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                  </div>
                </div>
                <div className="w-full">
                  <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                  <Skeleton className="w-full min-h-[45px]" variant="rounded-[6px]" />
                </div>
                <div className="w-full">
                  <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                  <Skeleton className="w-full min-h-[200px]" variant="rounded-[6px]" />
                </div>
              </div>
              <div className="secondary-bg-color shadow space-y-4 rounded-[6px] p-5 sm:p-[25px]">
                <div>
                  {t("lang_media")}
                  <p className="text-xs table-text font-normal">
                    {t("lang_Update_Blog_Details")}
                  </p>
                </div>
                <div className="w-full">
                  <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                  <Skeleton className="w-full min-h-[130px]" variant="rounded-[6px]" />
                </div>
                <div className="w-full">
                  <Skeleton className="w-[200px] mb-1" variant="rounded-[6px]" />
                  <Skeleton className="w-full min-h-[130px]" variant="rounded-[6px]" />
                </div>
              </div>
            </div>
          ) : (
            <form
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              method="POST"
              className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex flex-col gap-3"
            >
              <DetailsComponent
                open={true}
                hasHr={false}
                showChevron={false}
                className="!pt-5 sm:!pt-[25px]"
              >
                <div className="w-full mb-4">
                  <label htmlFor="title" className="flex items-center justify-between">
                    <p className="text-[13px]">
                      {t("lang_Blog_Title")}
                      <span className="text-red-500 ms-1">*</span>
                    </p>
                  </label>
                  <InputComponent
                    type="text"
                    name="title"
                    value={title}
                    onChange={(e) => {
                      const val = e.target.value;
                      setTitle(val);
                      setwarn(false);
                      setIsChange(true);
                      if (!enableSlug && (!slugEdited || !slugName)) handleSlug(val);
                      if (!isMetaTitleCustom) {
                        setMeta((prev) => ({ ...prev, meta_title: val }));
                      }
                    }}
                    placeholder="e.g. Tech"
                    onBlur={() => {
                      if (!enableSlug && (!slugEdited || !slugName) && title) handleSlug(title);
                      if (!isMetaTitleCustom && !meta_title && title) {
                        setMeta((prev) => ({ ...prev, meta_title: title }));
                      }
                    }}
                  />
                  <div className="flex items-center justify-between mt-1 text-xs text-gray-500 w-full gap-1 min-h-[24px]">
                    <div className="flex items-center w-[90%] min-w-0">
                      <a
                        href={`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/${(slugName || '').toLowerCase()}`}
                        target="_blank"
                        rel="noreferrer"
                        className="font-medium shrink-0 mr-2 hover:underline cursor-pointer text-blue-600 flex items-center"
                      >
                        Preview
                      </a>
                      {/* INLINE EDIT */}
                      {!enableSlug ? (
                        <div className="flex items-center gap-2 min-w-0">
                          <span className="truncate text-gray-500 min-w-0">
                            {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/${(slugName || '').toLowerCase()}`}
                          </span>

                          <button
                            type="button"
                            onClick={() => {
                              setEnableSlug(true);
                              setTimeout(() => slugInputRef.current?.focus(), 50);
                            }}
                            className="text-gray-600 hover:text-black shrink-0 flex items-center"
                          >
                            <Edit size={14} />
                          </button>
                        </div>
                      ) : (
                        <div className="flex items-center gap-1 min-w-0 flex-1">
                          <span className="text-gray-400 shrink truncate max-w-[120px] sm:max-w-[200px] md:max-w-[300px] lg:max-w-[400px]">
                            {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/`}
                          </span>

                          <InputComponent
                            ref={slugInputRef}
                            name="blog_slug_name"
                            className="flex-1 min-w-[60px] !h-[22px] !py-0.5 !px-1 text-xs"
                            value={slugName || ''}
                            onChange={(e) => {
                              setSlugName(e.target.value);
                              setSlugEdited(Boolean(e.target.value));
                              setIsChange(true);
                            }}
                            onBlur={async () => {
                              if (slugName) {
                                const generated = await GenerateSlugName(slugName);
                                setSlugName(generated);
                              }
                            }}
                            onKeyDown={async (e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                if (!slugName) {
                                  setIsNotification(true);
                                  setSeverity("warning");
                                  setNotificationMsg("Slug can not be empty!");
                                  return;
                                }
                                const generated = await GenerateSlugName(slugName);
                                setSlugName(generated);
                                setEnableSlug(false);
                                setSlugEdited(true);
                              }
                            }}
                            isSlug={true}
                          />

                          <button
                            type="button"
                            className="text-green-600 ml-1 shrink-0 flex items-center"
                            onClick={async () => {
                              if (!slugName) {
                                setIsNotification(true);
                                setSeverity("warning");
                                setNotificationMsg("Slug can not be empty!");
                                return;
                              }

                              const generated = await GenerateSlugName(slugName);
                              setSlugName(generated);
                              setEnableSlug(false);
                              setSlugEdited(true);
                            }}
                          >
                            <Check size={14} />
                          </button>
                        </div>
                      )}
                    </div>

                    <span className={`shrink-0 text-end w-[10%] flex items-center justify-end ${(title?.length || 0) > 60 ? 'text-red-500 font-semibold' : ''}`}>
                      {title?.length || 0}/60
                    </span>
                  </div>

                  {warn && (
                    <p className="text-sm text-red-500 mt-1">{t("lang_Please_Enter_Blog_Title")}</p>
                  )}
                </div>
                <div className="mb-4">
                  <label htmlFor="description">{t("lang_Blog_Category")}</label>
                  <SelectComponent
                    className="autocomplete"
                    options={categoryOptions}
                    getOptionLabel={(option) => {
                      if (!option) return '';
                      if (typeof option === 'string') return option;
                      return option?.blogcategory_name || option?.categoryName || (typeof option?.parent_category === 'string' ? option.parent_category.split('>').pop().trim() : '') || '';
                    }}
                    getOptionValue={(option) => option?._id}
                    filterOptions={filterOptionsForCategory}
                    onInputChange={(newInputValue) => {
                      if (typeof newInputValue === 'string' && newInputValue?.length >= 3) {
                        setHasSearched(false);
                        setAutocompleteSearch(newInputValue);
                      } else {
                        setIsCategoryLoading(false);
                        setHasSearched(false);
                        setAutocompleteSearch("");
                        setCategory([]);
                      }
                    }}
                    noOptionsText={
                      isCategoryLoading
                        ? `${t('lang_loading')}...`
                        : !autocompleteSearch || autocompleteSearch.length < 3 || !hasSearched
                          ? t('lang_enter_three_characters')
                          : t('lang_no_option_found')
                    }
                    onChange={(e, v) => {
                      const selectedCat = typeof v === 'object' && v !== null ? v : categoryOptions?.find(cat => cat._id === (e?.target?.value || v));
                      if (selectedCat) {
                        handleBlogCategory(
                          selectedCat._id,
                          selectedCat.blogcategory_name || selectedCat.categoryName || (typeof selectedCat.parent_category === 'string' ? selectedCat.parent_category.split('>').pop().trim() : '')
                        );
                      }
                    }}
                    placeholder={`${t('lang_select')} ${t('lang_category')}`}
                    tabIndex={2}
                  />
                  {SelectCategory?.map((elem, index) => {
                    return (
                      <span
                        key={index}
                        className="primary-bg-color table-text inline-flex items-center me-2 mt-1 min-w-[50px]  text-xs text-center px-3 capitalize py-1.5 rounded-[6px]"
                      >
                        {elem?.blogcategory_name}
                        <X
                          className="text-red-500 cursor-pointer h-[14px] w-[14px] ms-2"
                          onClick={() => removeCategory(elem?._id)}
                        />
                      </span>
                    );
                  })}
                </div>
                <div className="mb-4">
                  <label htmlFor="Description" className="block mb-1">{t("lang_Blog_Description")}</label>
                  <RichTextEditor
                    htmlData={secondDescription}
                    setHtmlData={setSecondDescription}
                    onAiGenerate={() => {
                      if (title === "") {
                        setwarn(true);
                      } else {
                        setGenareteAiPopup(true);
                        setwarn(false);
                      }
                    }}
                    uplaodImageFile={uploadTextEditorImage}
                  />
                  <div className="flex w-full justify-end mt-1">
                    <p className={`text-xs mt-0 ${(secondDescription?.split(/\s+/)?.filter(Boolean)?.length || 0) > 280 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                      {`${secondDescription?.split(/\s+/)?.filter(Boolean)?.length || 0}/280 words`}
                    </p>
                  </div>
                  {err && secondDescription?.length === 0 && (
                    <p className="text-red-500 text-xs mt-1">
                      {t("lang_Please_Enter_Description_For_Generate_Meta_Data")}
                    </p>
                  )}
                </div>
                <div className="mb-4">
                  <div className="flex items-center justify-between">
                    <label htmlFor="Description">{t("lang_Blog_Tags")}</label>
                  </div>
                  <InputComponent
                    type="text"
                    id="blog_tags"
                    name="blog_tags"
                    value={blogTagsValue}
                    onChange={(e) => {
                      setBlogTagsValue(e.target.value);
                      setIsChange(true);
                    }}
                    onKeyDown={(e) => (e.key === "Enter" ? SaveblogTagsValue() : "")}
                    placeholder="e.g. Black"
                  />
                  <p className="w-full text-xs mt-0 text-gray-400">
                    {t("lang_use")} <b className="table-text">{t("lang_Enter")}</b>{" "}
                    {t("lang_key_to_separate_tags")}
                  </p>
                  <div className="flex mt-1 flex-wrap items-center">
                    {blogTagsArray &&
                      blogTagsArray.map((elem, index) => {
                        return (
                          <span
                            key={index}
                            className="primary-bg-color table-text flex items-center me-2 mb-2 min-w-[50px]  text-xs text-center px-3 capitalize py-1.5 rounded-[6px]"
                          >
                            {elem}
                            <X
                              className="h-[14px] text-red-500 hover:text-red-700 w-[14px] ms-1 cursor-pointer"
                              onClick={() => RemoveTag(index)}
                            />
                          </span>
                        );
                      })}
                  </div>
                </div>
                {isCanSelectAuthor && (
                  <div className="mb-4">
                    <label>{authorLabel}</label>
                    <SelectComponent
                      value={selectedAuthor || ""}
                      onChange={(e, v) => {
                        const val = e?.target?.value !== undefined ? e.target.value : (typeof v === "object" && v !== null ? (v.value || v._id || v.user_id || v.id) : (v || ""));
                        setSelectedAuthor(val);
                        setIsChange(true);
                      }}
                      options={authorsList?.map((item) => ({
                        value: item._id || item.user_id || item.id,
                        label: item.name || `${item.first_name || ""} ${item.last_name || ""}`.trim() || item.email,
                      }))}
                      placeholder={authorPlaceholder}
                    />
                  </div>
                )}
                <div>
                  <label>Theme Template</label>
                  <SelectComponent
                    value={selectedTemplate || ""}
                    onChange={(e) => setSelectedTemplate(e.target.value)}
                    options={blogTemplate.length > 0
                      ? blogTemplate.map((item) => ({ value: item, label: item }))
                      : []
                    }
                    required
                  />
                </div>
                  <div className="mt-4">
                    <label>
                      {t("lang_Publish_Date") || "Publish Date"}
                    </label>
                    {scheduleTimeDate ? (
                      <div className="flex items-center gap-3">
                        <ButtonComponent
                          variant="outline"
                          type="button"
                          onClick={() => setIsSchedule(true)}
                        >
                          {t("lang_Update_Publish_Date") || "Update publish date"}
                        </ButtonComponent>
                        <div className="flex items-center justify-between px-3 py-2 bg-[#f8fafc] dark:bg-zinc-800/60 border border-gray-200 dark:border-zinc-700 rounded-lg flex-1">
                          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                            {new Date(scheduleTimeDate).toLocaleString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: false,
                            })}
                          </span>
                          <button
                            type="button"
                            className="text-red-500 hover:text-red-600 text-sm font-normal bg-transparent border-none p-0 cursor-pointer ml-3"
                            onClick={() => {
                              setScheduleTimeDate(null);
                              setIsChangeDate(true);
                              setIsChange(true);
                            }}
                          >
                            {t("lang_Clear") || "Clear"}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-center gap-3">
                        <ButtonComponent
                          variant="outline"
                          type="button"
                          onClick={() => setIsSchedule(true)}
                        >
                          {t("lang_Set_Publish_Date") || "Set publish date"}
                        </ButtonComponent>
                      </div>
                    )}
                  </div>
              </DetailsComponent>

              <DetailsComponent
                title={
                  <span>
                    {t("lang_media")}
                    <span className="text-red-500 ms-1">*</span>
                  </span>
                }
                subtitle={t("lang_Update_Blog_Details")}
                open={true}
              >
                <div>
                  <label htmlFor="Meta Tag Title" className="flex items-center justify-between mb-1">
                    <p>{t("lang_Image")}</p>
                    <span
                      className="inline-flex items-center cursor-pointer hover:underline text-[13px] rounded-[6px] transition duration-300 px-1"
                      onClick={() => setImageGenareteAiPopup(true)}
                    >
                      <BardSvg /> {t("lang_generate_image")}
                    </span>
                  </label>
                  <ImageUploader
                    alreadyImage={image}
                    handleSetImage={handleSetImage}
                    folder="blog"
                    format="image"
                  />
                </div>
              </DetailsComponent>

              <DetailsComponent
                title={t("lang_search_engine_listing")}
                subtitle={t("lang_search_engine_listing_detail")}
                contentClassName="px-4 sm:px-[25px] pb-4 sm:pb-[25px]"
              >
                <div className="w-full mb-4">
                  {meta_title?.length > 0 ? (
                    <div className="w-full bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition p-4 text-left flex gap-4 items-center justify-between">
                      <div className="flex-1">
                        <p className="text-[#1a0dab] text-[17px] font-medium leading-snug hover:underline cursor-pointer">
                          {meta_title}
                        </p>
                        <div className="flex items-center text-xs text-[#006621] mt-1">
                          {`${protocol}${clientInfo?.custom_domain || clientInfo?.customer_domain}${blogRoute}/${slugName}`}
                        </div>
                        <p
                          className="text-[#4d5156] text-sm mt-1 leading-relaxed line-clamp-3"
                          dangerouslySetInnerHTML={{ __html: meta_description }}
                        ></p>
                      </div>
                      {meta_image && (
                        <div className="w-32 h-20 shrink-0 rounded-lg overflow-hidden border border-gray-100 flex items-center justify-center bg-gray-50">
                          <img src={meta_image} className="w-full h-full object-contain" alt="Preview" />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="w-full bg-gray-50 border rounded-xl shadow-inner p-4 text-left secondary-bg-color main-border-color flex gap-4 items-center justify-between">
                      <div className="flex-1">
                        <p className="text-gray-400 text-[17px] font-medium leading-snug">
                          Example Blog Title
                        </p>
                        <div className="flex items-center text-xs text-gray-400 mt-1">
                          yourdomain.com/blog/sample-blog
                        </div>
                        <p className="text-gray-400 text-sm mt-1 leading-relaxed">
                          This is a sample meta description. When you add a title and description, your search engine preview will appear here.
                        </p>
                      </div>
                      {meta_image && (
                        <div className="w-32 h-20 shrink-0 rounded-lg overflow-hidden border border-gray-100 flex items-center justify-center bg-gray-50">
                          <img src={meta_image} className="w-full h-full object-contain" alt="Preview" />
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="mb-4">
                  <AiTextGenerate
                    fieldLabel={t("lang_meta_title")}
                    label={t("lang_get_meta_title")}
                    tooltip={t("lang_meta_tooltip", { type: "title" })}
                    onGenerate={() => generateMetaData(secondDescription || description, "title")}
                  />
                  <InputComponent
                    type="text"
                    id="Meta Tag Title"
                    name="meta_title"
                    value={meta_title}
                    onChange={(e) => {
                      setIsMetaTitleCustom(Boolean(e.target.value));
                      setMeta((prev) => ({ ...prev, [e.target.name]: e.target.value }));
                      setIsChange(true);
                    }}
                    placeholder="Enter meta title"
                  />
                  <div className="flex w-full justify-end mt-1">
                    <p className={`text-xs mt-0 ${(meta_title?.length || 0) > 60 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                      {`${meta_title?.length || 0}/60`}
                    </p>
                  </div>
                </div>
                <div className="mb-4">
                  <AiTextGenerate
                    fieldLabel={t("lang_meta_description")}
                    label={t("lang_get_meta_description")}
                    tooltip={t("lang_meta_tooltip", { type: "description" })}
                    onGenerate={() => generateMetaData(secondDescription || description, "description")}
                  />
                  <textarea
                    className="w-full h-24 block px-3 py-2 border border-[var(--border-color)] rounded-lg focus:outline-none focus:border-[var(--focus-border-color)] bg-[var(--secondary-bg-color)] text-[var(--primary-text-color)] text-sm"
                    id="Meta Tag description"
                    name="meta_description"
                    value={(meta_description || '').replace(/<[^>]+>/g, '')}
                    onChange={(e) => {
                      setMeta({ ...meta, [e.target.name]: e.target.value });
                      setIsChange(true);
                    }}
                    placeholder="Enter meta description"
                  />
                  <div className="flex w-full justify-end mt-1">
                    <p className={`text-xs mt-0 ${((meta_description || '').replace(/<[^>]+>/g, '').length || 0) > 160 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
                      {`${(meta_description || '').replace(/<[^>]+>/g, '').length || 0}/160 words`}
                    </p>
                  </div>
                </div>
                <div className="w-full">
                  <label htmlFor="meta_image">
                    <p className="text-[13px] mb-1">{t("lang_meta_image") || "OG Image"}</p>
                  </label>
                  <ImageUploader
                    tabIndex={16}
                    alreadyImage={meta_image}
                    handleSetImage={(value) => {
                      setMeta({ ...meta, meta_image: value });
                      setIsChange(true);
                    }}
                    folder="og"
                    format="image"
                    removeImages={() => {
                      setMeta({ ...meta, meta_image: "" });
                      setIsChange(true);
                    }}
                  />
                </div>
              </DetailsComponent>
              {isCustomField && (
                <UpdateCustomMetaField
                  meta_fields={meta_fields}
                  setmeta_fields={setmeta_fields}
                  heading="blog"
                  errors={customFieldErrors}
                  setErrors={setCustomFieldErrors}
                  metaFieldData={customFieldList}
                  setMetaFieldData={setCustomFieldList}
                  setIsChange={setIsChange}
                />
              )}
            </form>
          )}
        </div>
        <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-4 left-0">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto flex items-center justify-between">
            <Link
              onClick={(e) => {
                e.preventDefault();
                checkChanges();
              }}
              className="w-fit flex text-link font-medium hover:underline text-sm items-center "
            >
              <ArrowLeft className="w-3 mr-1" />
              {t("lang_Go_To_Blogs")}
            </Link>
            <div className="flex items-center gap-3">
              {title === "" || !image?.length || enableSlug ? (
                <>
                  <ButtonComponent variant="outline" disabled type="button">
                    {t("lang_Save_As_Draf") || "Save as draft"}
                  </ButtonComponent>
                  <ButtonComponent variant="primary" disabled type="button">
                    {scheduleTimeDate && new Date(scheduleTimeDate) > new Date()
                      ? (t("lang_Publish_Schedule") || "Publish schedule")
                      : (t("lang_Update_Blog_Post") || "Update blog post")}
                  </ButtonComponent>
                </>
              ) : btnLoading ? (
                <ButtonComponent variant="primary" loading type="button">
                    {t("lang_Saving")}...
                </ButtonComponent>
              ) : (
                    <>
                  <ButtonComponent
                        variant="outline"
                        type="button"
                        onClick={(e) => HandleUpdate(e, "draft")}
                  >
                        {t("lang_Save_As_Draf") || "Save as draft"}
                      </ButtonComponent>
                      <ButtonComponent
                        variant="primary"
                        type="button"
                        onClick={(e) => HandleUpdate(e, "publish")}
                      >
                        {scheduleTimeDate && new Date(scheduleTimeDate) > new Date()
                          ? (t("lang_Publish_Schedule") || "Publish schedule")
                          : (t("lang_Update_Blog_Post") || "Update blog post")}
                      </ButtonComponent>
                    </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={generateAiPopup}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setGenareteAiPopup(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="w-[350px] md:w-[500px] max-h-full">
          <div className="relative secondary-bg-color table-text shadow dark:bg-gray-700 p-5">
            <div className="flex items-center justify-between border-b main-border-color mb-3 pb-3 rounded-t dark:border-gray-600">
              <h6 className="flex items-center justify-between capitalize  text-primary font-medium gap-1">
                <BardSvg /> {t("lang_Generate_Blog_Description")}
              </h6>
              <button
                type="button"
                className="close-btn"
                onClick={() => {
                  setGenareteAiPopup(false);
                }}
              >
                <X className="h-4 w-4" aria-hidden="true" />
              </button>
            </div>
            <form
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
              onSubmit={handleSubmitAiData}
            >
              <div className="mb-4">
                <TextareaComponent
                  id="SKU ID"
                  name="features"
                  label={
                    <span className="flex items-center">
                      {t("lang_features_and_keywords")}
                      <Tooltip
                        title="Add features and keywords for better description"
                        arrow
                        placement="right"
                        className="ml-2 -tracking-tighter"
                      >
                        <QuestionCircleFill className="info-link cursor-pointer" />
                      </Tooltip>
                    </span>
                  }
                  value={gerenateAiData?.features}
                  onChange={handleChangeAiData}
                  placeholder="e.g. Organic cotten, relaxed fit"
                  rows={3}
                />
              </div>
              <ButtonComponent type="submit" variant="primary">
                {t("lang_generate")}
              </ButtonComponent>
            </form>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={generateDescriptionAiPopup}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setGenareteDescriptionAiPopup(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="w-[350px] md:w-[500px] max-h-full">
          <div className="relative secondary-bg-color table-text shadow dark:bg-gray-700 p-5">
            <div className="flex items-center justify-between border-b main-border-color mb-3 pb-3 rounded-t dark:border-gray-600">
              <h6 className="capitalize font-medium  text-primary">
                {t("lang_Generate_Blog_Description")}
              </h6>
              <button
                type="button"
                className="close-btn"
                onClick={() => {
                  setGenareteDescriptionAiPopup(false);
                }}
              >
                <X className="h-4 w-4" aria-hidden="true" />
              </button>
            </div>
            <form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
              <div className="mb-4">
                <label className="flex" htmlFor="SKU ID">
                  {t("lang_features_and_keywords")}
                  <Tooltip
                    title="Add features and keywords for better description"
                    arrow
                    placement="right"
                    className="ml-2 -tracking-tighter"
                  >
                    <QuestionCircleFill className="info-link cursor-pointer" />
                  </Tooltip>
                </label>
                <RichTextEditor
                  htmlData={description}
                  setHtmlData={setDescription}
                  uplaodImageFile={uploadTextEditorImage}
                />
              </div>
              <div className="flex justify-between">
                <ButtonComponent
                  type="button"
                  variant="primary"
                  onClick={() => {
                    setSecondDescription(description);
                    setGenareteDescriptionAiPopup(false);
                  }}
                >
                  {t("lang_generate")}
                </ButtonComponent>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={isSchedule}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setIsSchedule(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="w-full sm:w-[450px] p-6 rounded-[12px] bg-white dark:bg-zinc-900 text-gray-900 dark:text-zinc-100 shadow-xl flex flex-col">
          <div className="flex items-center justify-between pb-3 mb-4 border-b border-gray-200 dark:border-zinc-800">
            <h5 className="text-base font-semibold text-gray-900 dark:text-white m-0">
              {t("lang_Set_Publish_Date") || "Set publish date"}
            </h5>
            <button
              type="button"
              onClick={() => setIsSchedule(false)}
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 p-1 rounded-md transition-colors border-none bg-transparent cursor-pointer"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <div className="space-y-4">
            <div className="relative">
              <input
                type="text"
                readOnly
                value={
                  scheduleTimeDate
                    ? new Date(scheduleTimeDate).toLocaleDateString("en-US", {
                      month: "long",
                      day: "numeric",
                      year: "numeric",
                    }) +
                    " " +
                    new Date(scheduleTimeDate).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })
                    : ""
                }
                placeholder={t("lang_Select_Date_Time") || "Select date & time"}
                className="w-full px-3 py-2 border border-gray-200 dark:border-zinc-700 rounded-lg text-sm bg-gray-50 dark:bg-zinc-800 text-gray-900 dark:text-white pr-10 focus:outline-none"
              />
              <CalendarFill className="absolute right-3 top-3 w-4 h-4 text-gray-400" />
            </div>

            <div className="w-full min-h-[290px] custom-datepicker-inline flex justify-center">
              <div className="relative w-full flex justify-center">
                <DatePicker
                  className={`${scheduleTimeDate ? "bold-date" : ""} w-full px-3 py-2 border main-border-color rounded-[6px] focus:outline-none focus:border-gray-400`}
                  showTimeSelect
                  inline
                  selected={scheduleTimeDate ? new Date(scheduleTimeDate) : null}
                  onChange={(date) => {
                    setScheduleTimeDate(date);
                    setIsChangeDate(true);
                    setIsChange(true);
                  }}
                  dateFormat="MMMM d, yyyy h:mm aa"
                />
              </div>
            </div>

            <div className="pt-2">
              <ButtonComponent
                variant="primary"
                type="button"
                onClick={() => setIsSchedule(false)}
              >
                {t("lang_Done") || "Done"}
              </ButtonComponent>
            </div>
          </div>
        </div>
      </Dialog>

      {html?.htmlPP && (
        <SourceCode
          open={html?.htmlPP}
          htmlCode={html?.code}
          closeCode={closeCode}
          saveHTML={saveHTML}
        />
      )}
      {imageGenerateAiPopup && (
        <ImageGeneratePrompt
          imageGenerateAiPopup={imageGenerateAiPopup}
          setImageGenareteAiPopup={setImageGenareteAiPopup}
          imageGenerateAiData={imageGenerateAiData}
          imageWarn={imageWarn}
          setImageWarn={setImageWarn}
          handleChangeImageAiData={handleChangeImageAiData}
          handleSubmitAiImage={handleSubmitAiImage}
        />
      )}
      {isConfirmationImageOpen && (
        <ImageConfirmation
          heading="Image Confirmation"
          subheading="Do you want to keep this image in blog?"
          image={image}
          isConfirmationImageOpen={isConfirmationImageOpen}
          closeImageConfirmation={closeImageConfirmation}
          runFunction={handleImageUpload}
        />
      )}
    </>
  );
};

export default UpdateBlog;
